import { render, staticRenderFns } from "./movementStockAreaChart.vue?vue&type=template&id=4d316004&scoped=true"
import script from "./movementStockAreaChart.vue?vue&type=script&lang=js"
export * from "./movementStockAreaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d316004",
  null
  
)

export default component.exports